module.exports = __webpack_public_path__ + "static/media/damian-avila-wassat-art.8db8c536.png";